import type { BuildState } from '../types';

export const avatarComputeStats = (_b: BuildState): Record<string, number> => ({});
